import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import KlarnaConfirmation from 'components/KlarnaConfirmation';
import { StoreOverviewStore, AuthStore } from 'stores';
import { getCart } from 'selectors/store';

class KlarnaConfirmationContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));

    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      owner: state.owner,
      theme: state.theme,
      cart: getCart(state),
      store: state.name,
      method: state.payment.method,
      discountCode: state.discountCode,
      paymentLoading: state.payment.loading,
      snippet: (state.payment.data && state.payment.data.snippet) || ''
    }));
  }

  render() {
    const { transactionId } = this.props.params;
    return (
      <KlarnaConfirmation
        {...this.props}
        {...this.state}
        transactionId={transactionId}
      />
    );
  }
}

export default KlarnaConfirmationContainer;



// WEBPACK FOOTER //
// ./src/js/components/Route/KlarnaConfirmationContainer.js